const actions = {
  fetchPending: 'LOADING::SITES',
  fetchSites: 'FETCH::SITES',
  setSites: 'SET::SITES',
  resetSites: 'RESET::SITES'
}
export const getSites = state => state.sites
export default actions



// WEBPACK FOOTER //
// ./src/store/sites/actions.js